import i18n from 'modules/core/lib/i18n'

export function formatDate(iso: string): string {
  try {
    const d = new Date(iso)
    return d.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  } catch {
    return iso
  }
}

export function formatTimeRemaining(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined) return '—'
  if (seconds === 0) return i18n.t('ticketing.inbox.time_remaining.overdue')
  if (seconds < 0) {
    const elapsed = formatDuration(Math.abs(seconds))
    return i18n.t('ticketing.inbox.time_remaining.overdue_time', { time: elapsed })
  }
  return formatDuration(seconds)
}

function formatDuration(totalSeconds: number): string {
  const d = Math.floor(totalSeconds / 86400)
  const h = Math.floor((totalSeconds % 86400) / 3600)
  const m = Math.floor((totalSeconds % 3600) / 60)

  if (d > 0) {
    return h > 0 ? `${d}d ${h}h` : `${d}d`
  }
  if (h > 0) {
    return m > 0 ? `${h}h ${m}m` : `${h}h`
  }
  return `${m}m`
}

export function isOverdue(seconds: number | null | undefined): boolean {
  return seconds !== null && seconds !== undefined && seconds <= 0
}
